export const he = {
  common: {
    loading: 'טוען...',
    error: 'שגיאה',
    back: 'חזרה',
    logout: 'יציאה',
    language: 'English',
    save: 'שמור',
    cancel: 'ביטול',
    toggle_language: 'החלף שפה',
  },
  onboarding: {
    intro_headline: 'מערכת אחת לניהול כל העסק',
    intro_subline: 'יומן, לקוחות, שירותים והעמוד שלכם. הכל במקום',
    intro_cta: 'בואו נתחיל',
    signin_title: 'קודם כל, מי אתם',
    signin_subtitle: 'נשלח קוד למייל, ומשם ממשיכים להקמת העסק.',
    or: 'או',
    rail_label: 'פרקי ההקמה',
    rail_title: 'מקימים את העסק',
    rail_subtitle: 'אפשר למלא בכל סדר. שומרים לכם הכל תוך כדי.',
    chapter_identity: 'פרטי העסק',
    chapter_offering: 'השירותים',
    chapter_team: 'הצוות',
    chapter_hours: 'שעות העבודה',
    chapter_storefront: 'פרופיל העסק',
    chapter_pending: 'הפרק הזה עוד לא נבנה. השלד, הסימונים והטיוטה כבר עובדים.',
    identity_name_label: 'שם העסק',
    identity_name_placeholder: 'לדוגמה: מספרת רנה',
    identity_slug_label: 'כתובת הדף שלכם',
    identity_slug_free: 'הכתובת פנויה',
    identity_slug_taken: 'הכתובת תפוסה, בחרו אחרת',
    identity_address_label: 'כתובת העסק',
    identity_address_placeholder: 'התחילו להקליד ובחרו מהרשימה',
    identity_address_unpinned: 'בחרו כתובת מהרשימה כדי שנוכל לסמן אתכם על המפה',
    identity_trade_label: 'התחום הראשי',
    identity_multi_trade: 'העסק מציע יותר מתחום אחד',
    prompt_identity: 'שם, כתובת ותחום',
    prompt_offering: 'מה אתם מציעים',
    prompt_team: 'מי עובד אצלכם',
    prompt_hours: 'מתי אפשר לקבוע',
    prompt_storefront: 'תמונה, טלפון ומדיניות',
    summary_services: '{{count}} שירותים',
    summary_staff: '{{count}} אנשי צוות',
    summary_hours: 'שבוע מלא ל־{{count}}',
    summary_photo: 'תמונה',
    mark_todo: 'טרם התחלתם',
    mark_warn: 'התחלתם, חסרים פרטים',
    mark_done: 'הושלם',
    handoff: 'המשיכו בטלפון ←',
  },
  login: {
    // The door in front of the sign-in card. Its own keys, never the wizard's
    // `onboarding.intro_*` - those belong to the flow that CREATES a business
    // and would silently change it.
    intro_headline: 'מערכת אחת לניהול כל העסק',
    intro_subline: 'יומן, לקוחות, שירותים והעמוד שלכם. הכל במקום אחד.',
    intro_cta: 'כניסה לעסק',
    intro_new_business: 'עוד אין לכם עסק בסליקר? להקים עכשיו',
    // The way back to the door, from any step that still has one to go back to.
    back_to_email: 'חזרה לכתובת אחרת',
    // The code step's own title. `title` ('כניסה') stays for the email step.
    code_title: 'הקוד שנשלח אליכם',
    title: 'כניסה',
    email_label: 'כתובת אימייל',
    email_placeholder: 'name@example.com',
    send_code: 'שלח קוד',
    sign_in: 'התחבר',
    code_label: 'קוד אימות',
    code_placeholder: '6 ספרות',
    verify: 'אימות',
    sending: 'שולח...',
    verifying: 'מאמת...',
    email_code_sent_notice:
      'אם קיים חשבון המשויך לכתובת הזו, קוד אימות בדרך אליו. הקוד תקף ל-10 דקות.',
    create_business_title: 'בואו נקים את העסק שלכם',
    create_business_subtitle: 'עוד רגע אתם בפנים. אפשר לשנות הכל אחר כך.',
    create_business_name_label: 'שם העסק',
    create_business_name_placeholder: 'לדוגמה: מספרת רנה',
    create_business_slug_label: 'כתובת הדף שלכם',
    create_business_slug_hint: 'בחרנו לכם כתובת אקראית - אפשר לשנות אותה',
    create_business_submit: 'יצירת העסק',
    create_business_creating: 'יוצר...',
    select_business: 'בחר עסק',
    error_invalid_email: 'כתובת אימייל לא תקינה',
    error_invalid_code: 'קוד לא תקין',
    error_wrong_code: 'הקוד שגוי או פג תוקפו, נסה שוב',
    error_rate_limited: 'יותר מדי ניסיונות, נסה שוב מאוחר יותר',
    error_generic: 'שגיאה, נסה שוב',
    apple_button: 'המשך עם Apple',
    email_hint: 'נשלח לכם קוד במייל. אין צורך בחשבון קיים.',
    apple_error: 'ההתחברות עם Apple נכשלה, נסה שוב',
    apple_admin_blocked: 'התחברות עם Apple אינה זמינה לחשבונות מנהל. השתמש באימייל או ב-Google.',
    apple_private_relay:
      'כדי לחבר את החשבון לעסק שלכם צריך את כתובת האימייל האמיתית. כבו את האפשרות "הסתר את כתובת האימייל שלי" עבור Slikerr בהגדרות Apple ID, או התחברו עם Google או עם קוד במייל.',
    use_oauth_instead: 'הכתובת הזו כבר רשומה דרך Google או Apple. התחברו עם הכפתור המתאים.',
    iap_signin_failed:
      'ההתחברות האוטומטית לא עבדה עבור חשבון ה-Google הזה. התחברו למטה עם אימייל המנהל.',
    error_business_name_required: 'צריך למלא שם עסק',
    error_slug_taken: 'הכתובת הזו כבר תפוסה. נסו כתובת אחרת.',
  },
  phoneGate: {
    title: 'הוסיפו מספר טלפון מאומת',
    subtitle:
      'לקוחות מתקשרים אליכם ישירות דרך המספר הזה, וגם תזדקקו לו כדי להזמין תור בעסק אחר. זהו שלב חובה לפני הכניסה ללוח הבקרה.',
    phone_label: 'מספר טלפון',
    phone_placeholder: '05X-XXXXXXX',
    send_code: 'שלח קוד',
    sending: 'שולח...',
    code_label: 'קוד אימות (6 ספרות)',
    verify: 'אימות',
    verifying: 'מאמת...',
    change_number: 'שינוי מספר',
    wrong_code: 'הקוד שגוי או פג תוקפו, נסה שוב',
    rate_limited: 'יותר מדי ניסיונות, נסה שוב מאוחר יותר',
    already_linked: 'מספר זה כבר מאומת בחשבון אחר, נסה מספר אחר',
    generic_error: 'שגיאה, נסה שוב',
  },
  nav: {
    services: 'שירותים',
    staff: 'צוות ועמדות',
    calendar: 'יומן',
    clients: 'לקוחות',
    settings: 'הגדרות',
    growth: 'צמיחה',
    reminders: 'תזכורות',
    reviews: 'ביקורות',
    analytics: 'אנליטיקס',
    ai: 'סוכן AI',
    stealth_mode: "מצב סטֵלת'",
  },
  dashboard: {
    title: 'לוח בקרה',
    welcome: 'ברוך הבא',
  },
  settings: {
    title: 'הגדרות עסק',
    name_label: 'שם העסק',
    instagram_label: 'קישור אינסטגרם',
    instagram_placeholder: '@handle או https://instagram.com/…',
    save: 'שמור שינויים',
    saving: 'שומר...',
    success: 'הפרופיל עודכן בהצלחה',
    read_only_notice: 'צפייה בלבד - אין הרשאת עריכה',
    name_required: 'שם העסק הוא שדה חובה',
    // T25 — publish gate
    visibility_label: 'נראות עסק',
    published_status: 'מפורסם - דף ההזמנה פעיל',
    unpublished_status: 'מוסתר - דף ההזמנה מוחזיר 404',
    pending_review_status: 'העסק שלכם ממתין לאישור הצוות שלנו',
    pending_review_body:
      'אפשר להמשיך להגדיר שירותים, אנשי צוות ושעות פעילות. נודיע לכם ברגע שהדף יאושר לפרסום.',
    publish_button: 'פרסם',
    unpublish_button: 'הסתר',
    publish_saving: 'שומר...',
    publish_success: 'הנראות עודכנה בהצלחה',
    // T30 — overlap-confirm opt-in
    overlap_label: 'חפיפת תורים',
    overlap_description:
      'כשמופעל, שינוי מועד או קביעת תור שחופף לתור אחר של אותו איש/אשת צוות יבקש אישור במקום לחסום אוטומטית. שעות עבודה, הפסקות וימי חופש לא מושפעים לעולם.',
    overlap_enabled_status: 'מופעל - ניתן לאשר חפיפות',
    overlap_disabled_status: 'כבוי - חפיפות תמיד חסומות',
    overlap_enable_button: 'הפעל',
    overlap_disable_button: 'כבה',
    overlap_saving: 'שומר...',
    overlap_success: 'ההגדרה עודכנה בהצלחה',
    // קישור עמוד ההזמנה הציבורי
    share_link_label: 'קישור לדף ההזמנות שלך',
    share_link_copy_button: 'העתק קישור',
    share_link_copied: 'הועתק!',
    share_link_view_live: 'צפה בדף',
    share_link_preview: 'תצוגה מקדימה',
    share_link_unpublished_notice: 'הקישור לא יעבוד עד שתפרסם את העסק - ראה מתג הנראות למעלה.',
    // #95 - שדות הפרופיל שהלקוחות רואים (מרקטפלייס)
    marketplace_heading: 'הפרופיל שהלקוחות רואים',
    phone_label: 'טלפון העסק',
    phone_placeholder: '050-1234567',
    phone_too_long: 'מספר הטלפון ארוך מדי (עד 32 תווים)',
    address_label: 'כתובת',
    address_placeholder: 'התחילו להקליד וּבחרו מהרשימה',
    address_unpinned: 'בחרו כתובת מהרשימה כדי לשמור אותה - טקסט שהוקלד בלבד לא נשמר.',
    trade_label: 'תחום עיסוק ראשי',
    multi_trade_label: 'העסק מציע יותר מתחום אחד',
    secondary_trade_label: 'תחומים נוספים',
    description_label: 'על העסק',
    description_placeholder: 'כמה משפטים על העסק, שהלקוחות יראו בדף שלכם',
    description_too_long: 'התיאור ארוך מדי (עד 2000 תווים)',
    description_counter: '{count} / 2000',
    // #459 - מדיניות הזמנות. הניסוחים מועתקים כלשונם מ-bizPage.* באפליקציה
    // (apps/mobile/src/i18n/locales/he.json) - אותה שאלה לא תנוסח בשתי דרכים.
    policy_heading: 'מדיניות ותנאים',
    policy_not_set: 'טרם נבחר',
    policy_cancellation_label: 'עד כמה זמן לפני התור ניתן לבטל או לדחות בחינם?',
    policy_cancellation_required_hint: 'יש לבחור מדיניות ביטול כדי לפרסם את העסק',
    policy_cancellation_flexible: 'גמיש - ניתן לבטל בכל עת',
    policy_cancellation_1h: 'עד שעה לפני התור',
    policy_cancellation_2h: 'עד שעתיים לפני התור',
    policy_cancellation_6h: 'עד 6 שעות לפני התור',
    policy_cancellation_12h: 'עד 12 שעות לפני התור',
    policy_cancellation_24h: 'עד 24 שעות לפני התור',
    policy_cancellation_48h: 'עד 48 שעות לפני התור',
    policy_cancellation_72h: 'עד 72 שעות לפני התור',
    policy_late_arrival_label: 'כמה זמן איחור ניתן לאפשר לפני שהתור נחשב לא הגעה?',
    policy_late_arrival_none: 'ללא הקלה - איחור כלשהו ייחשב לא הגעה',
    policy_late_arrival_5: 'עד 5 דקות איחור',
    policy_late_arrival_10: 'עד 10 דקות איחור',
    policy_late_arrival_15: 'עד 15 דקות איחור',
    policy_late_arrival_20: 'עד 20 דקות איחור',
    policy_late_arrival_30: 'עד 30 דקות איחור',
    policy_no_show_label: 'מה קורה במקרה של אי-הגעה ללא ביטול?',
    policy_no_show_no_penalty: 'ללא השלכה - ניתן לקבוע תור חדש בכל עת',
    policy_no_show_may_restrict: 'אי-הגעה חוזרת עלולה להגביל קביעת תורים עתידיים',
    policy_no_show_fee_may_apply: 'ייתכן חיוב בגין אי-הגעה',
    policy_min_notice_label: 'כמה זמן מראש ניתן לקבוע תור?',
    policy_min_notice_none: 'ללא מגבלה - ניתן לקבוע תור בכל עת',
    policy_min_notice_1h: 'לפחות שעה מראש',
    policy_min_notice_2h: 'לפחות שעתיים מראש',
    policy_min_notice_6h: 'לפחות 6 שעות מראש',
    policy_min_notice_24h: 'לפחות 24 שעות מראש',
    policy_notes_label: 'הערות נוספות',
    policy_notes_placeholder:
      'לדוגמה: ביטול עד 24 שעות מראש, איחור מעל 15 דקות עלול לגרום לביטול התור',
    policy_notes_too_long: 'ההערות ארוכות מדי (עד 2000 תווים)',
    policy_notes_counter: '{count} / 2000',
  },
  services: {
    title: 'שירותים',
    new_service: 'שירות חדש',
    edit_service: 'עריכת שירות',
    name_label: 'שם השירות',
    vertical_label: 'תחום עיסוק',
    gender_label: 'מגדר',
    duration_label: 'משך (דקות)',
    buffer_before_label: 'חיץ לפני (דקות)',
    buffer_after_label: 'חיץ אחרי (דקות)',
    price_label: 'מחיר',
    currency_label: 'מטבע',
    status_label: 'סטטוס',
    active_badge: 'פעיל',
    archived_badge: 'מארכב',
    archive: 'ארכב',
    unarchive: 'שחזר',
    save: 'שמור',
    saving: 'שומר...',
    cancel: 'ביטול',
    success_created: 'השירות נוצר בהצלחה',
    success_updated: 'השירות עודכן בהצלחה',
    read_only_notice: 'צפייה בלבד - אין הרשאת עריכה',
    name_required: 'שם השירות הוא שדה חובה',
    duration_required: 'משך חייב להיות גדול מאפס',
    no_services: 'אין שירותים עדיין',
    actions_label: 'פעולות',
  },
  serviceCategories: {
    title: 'קטגוריות',
    add: 'קטגוריה חדשה',
    name_label: 'שם הקטגוריה',
    name_placeholder: 'לדוגמה: שיער, ציפורניים',
    rename: 'שנה שם',
    delete: 'מחק',
    move_up: 'העבר למעלה',
    move_down: 'העבר למטה',
    service_count: 'שירותים',
    has_services: 'יש בקטגוריה הזו שירותים. העבירו או מחקו אותם קודם.',
    empty: 'אין עדיין קטגוריות',
    picker_label: 'קטגוריה',
    required: 'יש לבחור קטגוריה',
  },
  vertical: {
    hair: 'שיער',
    nails: 'ציפורניים',
    lashes_brows: 'ריסים וגבות',
    makeup: 'איפור',
    facial: 'טיפולי פנים',
    massage: 'עיסוי',
    spa: 'ספא',
    barber: 'מספרת גברים',
    hair_removal: 'הסרת שיער',
    holistic: 'טיפולים הוליסטיים',
    dental: 'הלבנת שיניים',
    pet_grooming: 'טיפוח חיות מחמד',
  },
  gender: {
    men: 'גברים',
    women: 'נשים',
    unisex: 'יוניסקס',
  },
  staff: {
    title: 'צוות',
    new_staff: 'צוות חדש',
    edit_staff: 'עריכת חבר צוות',
    display_name_label: 'שם תצוגה',
    display_name_required: 'שם תצוגה הוא שדה חובה',
    active_badge: 'פעיל',
    inactive_badge: 'לא פעיל',
    save: 'שמור',
    saving: 'שומר...',
    cancel: 'ביטול',
    success_created: 'חבר הצוות נוצר בהצלחה',
    success_updated: 'חבר הצוות עודכן בהצלחה',
    services_label: 'שירותים',
    assign_services: 'שייך שירותים',
    save_services: 'שמור שירותים',
    read_only_notice: 'צפייה בלבד - אין הרשאת עריכה',
    no_staff: 'אין חברי צוות עדיין',
    status_label: 'סטטוס',
    deactivate: 'הפוך ללא פעיל',
    activate: 'הפוך לפעיל',
    // T20b: schedule editor
    manage_schedule: 'ניהול לוח זמנים',
    working_hours: 'שעות עבודה',
    breaks_title: 'הפסקות',
    time_off_title: 'ימי חופשה',
    save_hours: 'שמור שעות',
    save_breaks: 'שמור הפסקות',
    add_row: 'הוסף שורה',
    remove: 'הסר',
    add_time_off: 'הוסף חופשה',
    remove_time_off: 'הסר חופשה',
    starts_at_label: 'מתאריך ושעה',
    ends_at_label: 'עד תאריך ושעה',
    reason_label: 'סיבה',
    no_time_off: 'אין ימי חופשה',
    start_time_label: 'שעת התחלה',
    end_time_label: 'שעת סיום',
    day_of_week_label: 'יום בשבוע',
    day_sun: 'ראשון',
    day_mon: 'שני',
    day_tue: 'שלישי',
    day_wed: 'רביעי',
    day_thu: 'חמישי',
    day_fri: 'שישי',
    day_sat: 'שבת',
  },
  clients: {
    title: 'לקוחות',
    search_placeholder: 'חפש לפי שם או טלפון',
    name_label: 'שם',
    phone_label: 'טלפון',
    bookings_label: 'הזמנות',
    appointments_chip_label: 'תורים',
    last_visit_label: 'ביקור אחרון',
    no_visits_yet: 'טרם ביקר/ה',
    no_clients: 'אין לקוחות עדיין',
    next_page: 'הדף הבא',
    loading_more: 'טוען...',
    back_to_list: 'חזרה לרשימת לקוחות',
    booking_history: 'היסטוריית הזמנות',
    no_bookings: 'אין הזמנות',
    service_label: 'שירות',
    staff_label: 'נותן שירות',
    date_label: 'תאריך',
    status_label: 'סטטוס',
    not_found: 'לקוח לא נמצא',
    unknown: 'לא ידוע',
    registered_at_label: 'תאריך הרשמה',
    tags_label: 'תגיות',
    add_tag_placeholder: 'הוסף תגית...',
    add_tag_action: 'הוספת תגית',
    remove_tag_aria: 'הסר תגית',
    no_tags: 'אין תגיות עדיין',
  },
  calendar: {
    title: 'לוח שנה',
    today: 'היום',
    new_booking: 'הזמנה חדשה',
    no_appointments: 'אין תורים ביום זה',
    loading: 'טוען...',
    // Appointment card
    status_scheduled: 'מתוכנן',
    status_cancelled: 'בוטל',
    status_completed: 'הושלם',
    status_no_show: 'לא הגיע',
    reschedule: 'שינוי מועד',
    cancel_appt: 'ביטול תור',
    // New booking form
    booking_form_title: 'הזמנה חדשה',
    phone_label: 'טלפון לקוח',
    phone_placeholder: '05X-XXXXXXX',
    name_label: 'שם לקוח (אופציונלי)',
    service_label: 'שירות',
    staff_label: 'איש צוות',
    datetime_label: 'תאריך ושעה',
    submit_booking: 'צור הזמנה',
    submitting: 'שולח...',
    booking_success: 'הזמנה נוצרה בהצלחה',
    slot_unavailable: 'השעה המבוקשת אינה פנויה, אנא בחר שעה אחרת',
    duplicate_service_booking: 'ללקוח/ה כבר יש תור לשירות הזה באותו היום',
    phone_invalid: 'מספר טלפון לא תקין',
    // Reschedule form
    reschedule_title: 'שינוי מועד תור',
    reschedule_submit: 'שנה מועד',
    reschedule_success: 'המועד שונה בהצלחה',
    // Cancel
    cancel_confirm: 'האם לבטל את התור?',
    cancel_confirm_title: 'אישור ביטול תור',
    cancel_confirm_yes: 'אשר ביטול',
    cancel_confirm_no: 'שמור תור',
    cancel_success: 'התור בוטל',
    // Filters
    filter_staff: 'סנן לפי איש צוות',
    all_staff: 'כל הצוות',
    // Select placeholders
    select_service: 'בחר שירות',
    select_staff: 'בחר איש צוות',
    // T30 — overlap confirm (only shown when the business turned this on)
    overlap_conflict_title: 'יש חפיפה של {{minutes}} דקות',
    overlap_conflict_divider: 'חופף',
    overlap_book_anyway: 'שבץ בכל זאת',
    overlap_pick_another: 'בחר/י שעה אחרת',
    overlap_confirming: 'משבץ...',
    // T31 — hours-override confirm (only shown when the business turned this on)
    hours_override_title: 'מחוץ לשעות פעילות',
    hours_override_body: 'השעה הזו מחוץ לשעות הפעילות של איש/אשת הצוות.',
    // Day grid — "no staff working these hours" hatch
    staff_off_today: 'לא עובד/ת היום',
  },
  public: {
    // Business page — T22
    not_found: 'העסק לא נמצא',
    services_title: 'שירותים',
    no_services: 'אין שירותים זמינים',
    all_categories: 'הכול',
    select_service: 'שירות',
    select_service_placeholder: 'בחר שירות',
    select_staff: 'נותן שירות',
    select_staff_placeholder: 'בחר נותן שירות',
    select_date: 'תאריך',
    minutes: 'דק׳',
    available_slots: 'שעות פנויות',
    no_slots: 'אין שעות פנויות ביום זה',
    instagram: 'אינסטגרם',
    facebook: 'פייסבוק',
    tiktok: 'טיקטוק',
    whatsapp: 'וואטסאפ',
    follow_us: 'עקבו אחרינו',
    about_title: 'על העסק',
    get_directions: 'קבלת הוראות הגעה',
    location_title: 'מיקום',
    coming_next: 'בקרוב',
    // Booking flow — T23a
    book_slot: 'הזמן תור',
    phone_label: 'מספר טלפון',
    phone_placeholder: '05X-XXXXXXX',
    send_code: 'שלח קוד',
    sending: 'שולח...',
    code_label: 'קוד אימות (6 ספרות)',
    verify_and_book: 'אמת והזמן',
    verifying: 'מאמת...',
    booking: 'מזמין...',
    back: 'חזרה',
    wrong_code: 'הקוד שגוי או פג תוקפו, נסה שוב',
    rate_limited: 'יותר מדי ניסיונות, נסה שוב מאוחר יותר',
    slot_unavailable: 'השעה הזו כבר נתפסה - אנא בחר שעה אחרת',
    duplicate_service_booking: 'כבר יש לך תור לשירות הזה באותו היום',
    slot_in_past: 'השעה הזו כבר עברה - אנא בחר שעה עתידית',
    booking_confirmed: 'הזמנתך אושרה!',
    booking_confirmed_detail: 'פרטי התור',
    booking_error: 'שגיאה ביצירת ההזמנה, נסה שוב',
    select_slot_first: 'יש לבחור שעה לפני ההזמנה',
    service_label: 'שירות',
    staff_label: 'נותן שירות',
    status_label: 'סטטוס',
    status_pending: 'מתוזמן',
    status_scheduled: 'מתוזמן',
    status_cancelled: 'בוטל',
    status_completed: 'הושלם',
    status_no_show: 'לא הגיע',
    // Manage booking — T23b
    manage_booking: 'ניהול הזמנה',
    reschedule: 'שנה מועד',
    reschedule_success: 'המועד שונה בהצלחה',
    cancel_booking: 'בטל הזמנה',
    cancel_confirm: 'האם לבטל את ההזמנה?',
    cancel_confirm_yes: 'אשר ביטול',
    cancel_confirm_no: 'השאר',
    cancel_success: 'ההזמנה בוטלה',
    session_expired: 'פגה תוקפה - אמת שוב את הטלפון',
    pick_new_slot: 'בחר שעה חדשה',
    // Calendar export — T24
    add_to_calendar: 'הוסף ליומן',
    add_to_calendar_loading: 'מוריד...',
    // T4 redesign — slot picker
    pick_date_time_title: 'בחירת מועד',
    confirm_slot: 'אישור הזמנה',
    choose_time: 'בחר/י שעה',
    morning_group: 'בוקר',
    noon_group: 'צהריים',
    evening_group: 'ערב',
    // T5 redesign — hero, rating, open status, category
    no_reviews_yet: 'טרם התקבלו ביקורות',
    open_until: 'פתוח · נסגר ב-{time}',
    closed_today: 'סגור היום',
    category_hair: 'מספרה',
    category_nails: 'ציפורניים',
    category_lashes_brows: 'גבות וריסים',
    category_makeup: 'איפור',
    category_facial: 'טיפולי פנים',
    category_massage: 'עיסוי',
    category_spa: 'ספא',
    category_barber: 'מספרת גברים',
    category_hair_removal: 'הסרת שיער',
    category_holistic: 'טיפולים הוליסטיים',
    category_dental: 'הלבנת שיניים',
    category_pet_grooming: 'טיפוח חיות מחמד',
    // #117 — ONE string for both `suspended` and `closed`. They must read
    // identically to a customer, and this must never hint at why: the reason
    // is console-only free text and may say "not paying".
    not_trading: 'העסק הזה לא מקבל הזמנות כרגע',
  },
  not_found: {
    code_label: 'שגיאה 404',
    title: 'הדף הזה לא קיים',
    body: 'יכול להיות שהקישור השתנה, או שנפלה טעות בכתובת.',
    home: 'חזרה לדף הבית',
  },
} as const;
